import Page from "components/the-buzz-theme/page/page";

import {
  getRecentPosts,
  getStickyPosts,
  getCategoryTabs,
  getTags,
  ITEMS_PER_QUERY,
} from "lib/api";
import { GetStaticPropsContext } from "next";
import * as React from "react";
import { NextSeo } from "next-seo";
import { getLocale } from "lib/localization";
import { FontsCircular } from "lib/scripts";
import { SupportedLanguage } from "lib/lexemes/supported-languages";

export type Props = {
  seo?: {
    title?: string;
    description?: string;
  };
  title?: string;
  image?: {
    alt?: string;
    src?: string;
    width?: number;
    height?: number;
  };
  tags?:
    | undefined
    | {
        name: string;
        count: number;
        slug: string;
      }[];
};

export default function ArticlePage(props: React.PropsWithChildren<Props>) {
  return (
    <>
      <NextSeo
        title={props.seo?.title || props?.title || "Bumble Buzz"}
        openGraph={{
          title: props.seo?.title || props?.title || "Bumble Buzz",
          description: props.seo?.description,
          images: props.image?.src
            ? [
                {
                  alt: props.image?.alt,
                  url: props.image?.src,
                  width: props.image?.width,
                  height: props.image?.height,
                },
              ]
            : undefined,
        }}
      />
      <FontsCircular />

      <Page tags={props.tags}>{props.children}</Page>
    </>
  );
}

export const getStaticProps = async function getStaticProps({
  params,
  preview = false,
}: GetStaticPropsContext<{ lang: SupportedLanguage }>) {
  const lang = getLocale(undefined, params);

  const [{ stickyPosts }, { categoryTabs }, recentPosts, { tags }] =
    await Promise.all([
      getStickyPosts(),
      getCategoryTabs({}),
      getRecentPosts(ITEMS_PER_QUERY),
      getTags(),
    ]);

  return {
    props: {
      lang,
      preview,
      stickyPosts,
      categoryTabs,
      recentPosts,
      tags,
    },
    revalidate: 20,
  };
};
